module.exports = __webpack_public_path__ + "img/arch1.42214956.jpg";